<template>
    <div class="ma-4">
        <v-snackbar v-model="msg" top>
            {{ text }}
            <v-btn color="pink" text @click="msg = false"> Close</v-btn>
        </v-snackbar
        >
        <ClientNav/>
        <v-card>
            <v-form ref="form" lazy-validation>
                <v-card-text>
                    <v-container>
                        <v-row>
                            <v-col cols="12">
                                <span>Is this related to a Support Strategy?</span>
                                <v-row>
                                    <v-col cols="12" sm="2">
                                        <v-checkbox
                                            label="Yes"
                                            value="Yes"
                                            v-model="supportStrategy"
                                        ></v-checkbox>
                                    </v-col>
                                    <v-col cols="12" sm="2">
                                        <v-checkbox
                                            label="No"
                                            value="No"
                                            v-model="supportStrategy"
                                        ></v-checkbox>
                                    </v-col>
                                    <v-col cols="12" sm="8" v-if="supportStrategy === 'Yes'">
                                        <v-select
                                            label="Select Support Strategy"
                                            :items="strategies"
                                            item-text="Goal"
                                            item-value="_id"
                                            v-model="strategy"
                                            return-object
                                        ></v-select>
                                        <v-select 
                                            v-model="newServiceCodes"
                                            label="Service Code"
                                            :items="serviceCodesSelection"
                                            item-text="ServiceCode"
                                            item-value="_id"
                                            multiple
                                        ></v-select>
                                    </v-col>
                                </v-row>
                            </v-col>
                            <v-col cols="12">
                                <span>Is this related to a Human Rights Restriction?</span>
                                <v-row>
                                    <v-col cols="12" sm="2">
                                        <v-checkbox
                                            label="Yes"
                                            value="Yes"
                                            v-model="HRC"
                                        ></v-checkbox>
                                    </v-col>

                                    <v-col cols="12" sm="2">
                                        <v-checkbox
                                            label="No"
                                            value="No"
                                            v-model="HRC"
                                        ></v-checkbox>
                                    </v-col>

                                    <v-col cols="12" sm="8" v-if="HRC === 'Yes'">
                                        <v-select
                                            return-object
                                            label="Select Human Rights"
                                            :items="rights"
                                            item-text="Restriction"
                                            item-value="_id"
                                            v-model="restriction"
                                            @change="updateRightsData(restriction)"
                                        ></v-select>
                                    </v-col>
                                </v-row>
                            </v-col>

                            <v-col cols="12" sm="12" md="3">
                                <v-select
                                    v-model="newServiceItem"
                                    label="Service Item"
                                    :items="serviceItems"
                                    :rules="requiredField"
                                    @input="createServiceItem"
                                >
                                    <template v-slot:append-item v-if="!isAuditorRole">
                                        <v-divider class="mb-2"></v-divider>
                                        <v-btn
                                            class="ma-2 white--text"
                                            color="success"
                                            @click="showServiceItemDialog()"
                                        >
                                            Add New Item
                                        </v-btn>
                                    </template>
                                </v-select>
                            </v-col>
                            <v-col cols="12" sm="12" md="3">
                                <v-select
                                    v-model="newType"
                                    label="Time to be completed"
                                    :items="type"
                                    :rules="requiredField"
                                ></v-select>
                            </v-col>
                            <v-col cols="12" sm="12" md="3">
                                <v-select
                                    v-model="newScheduledTime"
                                    label="Scheduled Time"
                                    :items="scheduledTime"
                                    :rules="requiredList"
                                    multiple
                                ></v-select>
                            </v-col>
                            <v-col class="d-flex" cols="12" sm="12" md="3">
                                <v-select
                                    v-model="newProvider"
                                    label="Provider"
                                    :items="provider"
                                    :rules="requiredField"
                                    clearable
                                ></v-select>
                            </v-col>
                            <v-col class="d-flex" cols="12" sm="12" md="3">
                                <v-select
                                    v-model="newLOA"
                                    label="Level of Assistance"
                                    :items="loa"
                                    :rules="requiredField"
                                ></v-select>
                            </v-col>
                            <v-col class="d-flex" cols="12" sm="12" md="3">
                                <v-select
                                    v-model="newDays"
                                    label="Days"
                                    :items="days"
                                    multiple
                                    :rules="requiredList"
                                ></v-select>
                            </v-col>
                            <v-col class="d-flex" cols="12" sm="12">
                                <v-textarea
                                    v-model="newDescription"
                                    label="Description"
                                    outlined
                                    :rules="requiredField"
                                ></v-textarea>
                            </v-col>
                            <v-col class="d-flex" cols="12" sm="12">
                                <v-textarea
                                    v-model="newInstructions"
                                    label="Instructions"
                                    outlined
                                    :rules="requiredField"
                                ></v-textarea>
                            </v-col>
                            <v-col cols="12" sm="6">
                                <v-menu
                                    ref="menu"
                                    v-model="menu"
                                    :close-on-content-click="false"
                                    :return-value.sync="date"
                                    transition="scale-transition"
                                    offset-y
                                    min-width="auto"
                                >
                                    <template v-slot:activator="{ on, attrs }">
                                        <v-text-field
                                            v-model="newStartDate"
                                            label="Start Date"
                                            prepend-icon="mdi-calendar"
                                            readonly
                                            v-bind="attrs"
                                            v-on="on"
                                            clearable
                                        ></v-text-field>
                                    </template>
                                    <v-date-picker v-model="newStartDate" no-title scrollable>
                                        <v-spacer></v-spacer>
                                        <v-btn text color="primary" @click="menu = false">
                                            Cancel
                                        </v-btn>
                                        <v-btn text color="primary" @click="$refs.menu.save(date)">
                                            OK
                                        </v-btn>
                                    </v-date-picker>
                                </v-menu>
                            </v-col>
                            <v-col cols="12" sm="6">
                                <v-menu
                                    ref="menu2"
                                    v-model="menu2"
                                    :close-on-content-click="false"
                                    :return-value.sync="date"
                                    transition="scale-transition"
                                    offset-y
                                    min-width="auto"
                                >
                                    <template v-slot:activator="{ on, attrs }">
                                        <v-text-field
                                            v-model="newEndDate"
                                            label="End Date"
                                            prepend-icon="mdi-calendar"
                                            readonly
                                            v-bind="attrs"
                                            v-on="on"
                                            clearable
                                        ></v-text-field>
                                    </template>
                                    <v-date-picker v-model="newEndDate" no-title scrollable>
                                        <v-spacer></v-spacer>
                                        <v-btn text color="primary" @click="menu2 = false">
                                            Cancel
                                        </v-btn>
                                        <v-btn text color="primary" @click="$refs.menu2.save(date)">
                                            OK
                                        </v-btn>
                                    </v-date-picker>
                                </v-menu>
                            </v-col>
                            <v-col cols="12" sm="3">
                                <v-select
                                    label="Status"
                                    :items="status"
                                    v-model="newActive"
                                    required
                                    :rules="requiredField"
                                >
                                </v-select>
                            </v-col>
                        </v-row>
                    </v-container>
                </v-card-text>

                <v-card-actions>
                    <v-spacer></v-spacer>
                    <v-btn
                        fab
                        small
                        @click="showPrint()"
                        class="mr-8 mb-2 white--text"
                        color="#2b6993"
                        elevation="4"
                        v-if="$route.query.new"
                    >
                        <v-icon>print</v-icon>
                    </v-btn>
                    <v-btn
                        class="white--text"
                        color="#259647"
                        @click="addService()"
                        v-if="mode === 'add' && !isAuditorRole"
                    >Save
                    </v-btn
                    >
                    <v-btn
                        class="white--text"
                        color="#259647"
                        @click="updateService()"
                        v-if="$route.query.new && !isAuditorRole"
                    >Update
                    </v-btn
                    >
                    <v-btn
                        color="blue darken-1"
                        text
                        @click="close()"
                    >Close
                    </v-btn
                    >
                </v-card-actions>
            </v-form>
        </v-card>
        <v-dialog
            v-model="serviceItemDialog"
            max-width="500px"
            transition="dialog-top-transition"
        >
            <v-card>
                <v-toolbar color="primary" dark>Add Service Item</v-toolbar>
                <v-card-text>
                    <v-form>
                        <v-text-field
                            label="Item Name*"
                            :rules="requiredField"
                            v-model="newServiceItemAdd"
                        ></v-text-field>
                    </v-form>
                </v-card-text>
                <v-card-actions>
                    <v-spacer></v-spacer>
                    <v-btn color="primary" text @click="serviceItemDialog = false">
                        Close
                    </v-btn>
                    <v-btn class="white--text" color="#259647" @click="addServiceItem()"
                    >Save
                    </v-btn
                    >
                </v-card-actions>
            </v-card>
        </v-dialog>
        <Foot/>
    </div>
</template>

<script>
/*eslint-disable */
import axios from "axios";
import ClientNav from "@/components/ClientNav";
import ClientSide from "@/components/ClientSide";
import Foot from "@/components/Footer";
import moment from "moment";
import {mapGetters, mapActions} from "vuex";
import {setUserTz, tz, testTz} from "../../../../utils/timezone";
import {ValidationObserver, ValidationProvider} from "vee-validate";
import Swal from "sweetalert2";
import PrintUtil from "../../../../utils/print-util";

const url = require("../../../client_config/config").url;

const MORNING = ["6:00am", "7:00am", "8:00am", "9:00am", "10:00am", "11:00am"];
const AFTERNOON = ["12:00pm", "1:00pm", "2:00pm", "3:00pm", "4:00pm", "5:00pm"];
const EVENING = [
    "6:00pm",
    "7:00pm",
    "8:00pm",
    "9:00pm",
    "10:00pm",
    "11:00pm",
    "12:00am",
    "1:00am",
    "2:00am",
    "3:00am",
    "4:00am",
    "5:00am",
];

export default {
    components: {
        ClientNav,
        ClientSide,
        Foot,
        ValidationProvider,
        ValidationObserver,
    },
    props: {
        mode: {
            type: String,
        },
    },
    data: function () {
        return {
            tab: null,
            items: ["Active Service Plan", "Disabled Service Plan"],
            date: new Date(Date.now() - new Date().getTimezoneOffset() * 60000)
                .toISOString()
                .substr(0, 10),
            menu: false,
            menu2: false,
            dialog: false,
            editService: false,
            newService: false,
            msg: false,
            search: "",
            text: "",
            activeStrategies: [],
            humanRights: [],
            HRC: "",
            habs: [],
            supportStrategy: "",
            habPlan: "",
            strategy: "",
            restriction: "",
            services: [],
            disabledServices: [],
            tempServices: [],
            codes: [],
            tempData: [],
            clientID: this.$route.params.clientID,
            type: ["Morning", "Afternoon", "Night"],
            /* serviceItems: ["Activities", "Attitude and Behavior", "Ambulation", "Bathing/Showering", "Bed Making", "Behavioral Management",
            "Breakfast", "Cleaning Bedroom", "Dinner", "Dressing", "Financial Management", "Grooming", "Hair", "Housekeeping",
            "Laundry", "Lunch", "Mobility", "Oral", "Reading", "Shave", "Toileting", "Education/Schooling", "Physical Fitness"],*/
            serviceItems: [],
            // provider: ["Behaviorist", "CNA", "Cook", "Direct Care Staff", "Housekeeper", "Nurse", "Program Manager", "Yard Maintenance"], //old provider list
            provider: [
                "Day Program Staff",
                "Direct Care Staff",
                "House Staff",
                "JDT Staff",
            ],
            status: ["Active", "Disabled"],
            loa: [
                "Independant",
                "Minimal Assistance",
                "Moderate Assistance",
                "Total Assistance",
            ],
            days: [
                "Sunday",
                "Monday",
                "Tuesday",
                "Wednesday",
                "Thursday",
                "Friday",
                "Saturday",
            ],
            scheduledTime: [
                "12:00am",
                "1:00am",
                "2:00am",
                "3:00am",
                "4:00am",
                "5:00am",
                "6:00am",
                "7:00am",
                "8:00am",
                "9:00am",
                "10:00am",
                "11:00am",
                "12:00pm",
                "1:00pm",
                "2:00pm",
                "3:00pm",
                "4:00pm",
                "5:00pm",
                "6:00pm",
                "7:00pm",
                "8:00pm",
                "9:00pm",
                "10:00pm",
                "11:00pm",
                "PRN"
            ],
            titleForm: "New Service Item",
            serviceID: "",
            token: localStorage.getItem('token'),
            newServiceItem: "",
            newType: "",
            newScheduledTime: [],
            newProvider: "",
            newLOA: "",
            newDays: [],
            rights: [],
            newDescription: "",
            newInstructions: "",
            newStartDate: moment(new Date()).format("YYYY-MM-DD"),
            newEndDate: moment(new Date()).add(1, "Year").format("YYYY-MM-DD"),
            newActive: "",
            editedIndex: -1,
            editedItem: {
                serviceItem: "",
                type: "",
                scheduledTime: [],
                supportStrategy: "",
                strategy: "",
                provider: "",
                loa: "",
                days: [],
                description: "",
                instructions: "",
                startDate: "",
                endDate: "",
                active: "",
            },
            defaultItem: {
                serviceItem: "",
                type: "",
                scheduledTime: [],
                supportStrategy: "",
                strategy: "",
                provider: "",
                loa: "",
                days: [],
                description: "",
                instructions: "",
                startDate: "",
                endDate: "",
                active: "",
            },
            isLoading: true,
            requiredField: [(v) => !!v || "This is required"],
            requiredList: [(v) => v.length > 0 || "This is required"],
            serviceItemDialog: false,
            newServiceItemAdd: "",
            newServiceCodes: [],
            selectedStrategy: {},
        };
    },

    computed: {
        ...mapGetters(["getUserTimezone", "getDefaultTz"]),
        formTitle() {
            return this.editedIndex != 1 ? "New Item" : "Edit Item";
        },
        userTimezone() {
            const data = {
                userTimezone: this.getUserTimezone,
                defaultTz: this.getDefaultTz,
            };
            return setUserTz(data);
        },

        related() {
            let title = "Is this related to the";
            let state = this.$store.state.users.user.State === "Nevada";
            return {
                title: state ? `${title} HAB plan?` : `${title} Support Strategy?`,
                state: state ? true : false,
            };
        },
        isAuditorRole() {
            return localStorage.getItem("userRole") === 'Auditor'
        },
        formServiceCodes() {
            if (this.supportStrategy === 'Yes') {
                return this.strategy.ServiceCodes.filter((code) => {
                    return this.newServiceCodes.includes(code._id);
                });
            }

            return [];
        },
        serviceCodesSelection() {
            return this.strategy?.ServiceCodes ?? [];
        },
        strategies() {
            let strategies = this.activeStrategies;
            let {Active, Goal, _id} = this.selectedStrategy;
            if (Active === "Active" || Active === undefined) {
                return strategies;
            }

            let hasSameGoal = strategies.find((strategy) => 
                strategy.Goal?.trim() == Goal?.trim()
            );
            console.log(Active, Goal, hasSameGoal);
            if (Active !== undefined && hasSameGoal == undefined ){
                strategies.push(this.selectedStrategy);
            } 
            return strategies;
        }
    },

    async created() {
        this.getRights();
        this.getServiceItem();
        this.getSupportStrategies();
        this.getHabs();
        if (this.$route.query?.id) {
            this.getServices();
        }
    },

    mounted() {
        window.addEventListener('keydown', async (event) => {
            const downloadUrl = await this.generateDownloadUrl();
            PrintUtil.handleKeydown(event, downloadUrl, this.serviceID, this.token, 'ServicePlan');
        });
    },

    beforeDestroy() {
        window.removeEventListener('keydown', (event) => {
            PrintUtil.handleKeydown(event, this.downloadUrl, this.serviceID, this.token, 'ServicePlan');
        });
    },

    methods: {
        initialize() {
            this.services = [];
        },
        validate() {
            return this.$refs.form.validate();
        },
        validateReset() {
            if (this.$refs.form !== undefined) {
                this.$refs.form.reset();
            }
        },
        viewService(item) {
            this.getSupportStrategy(item.SupportStrategy);
            this.titleForm = "Viewing Service Item";
            this.dialog = true;
            this.editService = true;
            this.newService = false;
            this.newServiceItem = item.ServiceItem;
            this.supportStrategy = item.Support;
            this.strategy = item.Strategy;
            this.HRC = item.Right;
            this.restriction = item.HumanRights;
            this.newType = item.Type;
            this.newScheduledTime = item.ScheduledTime;
            this.newProvider = item.Provider;
            this.newLOA = item.LOA;
            this.newDays = item.Days;
            this.newDescription = item.Description;
            this.newInstructions = item.Instructions;
            this.newStartDate = moment(item.StartDate).format("YYYY-MM-DD");
            this.newEndDate = moment(item.EndDate).format("YYYY-MM-DD");
            this.newActive = item.Active;
            this.serviceID = item._id;
            this.newServiceCodes = item?.ServiceCodes ?? [];
            this.strategy = this.strategies.find((strategy) => (strategy._id === item.SupportStrategy || strategy.Goal?.trim() === item.Strategy?.trim()));
        },

        updateService() {
            let req_body = {
                ServiceItem: this.newServiceItem,
                Type: this.newType,
                ScheduledTime: this.newScheduledTime,
                Right: this.HRC,
                HumanRights: this.restriction,
                Provider: this.newProvider,
                LOA: this.newLOA,
                Days: this.newDays,
                Description: this.newDescription,
                Instructions: this.newInstructions,
                StartDate: this.newStartDate,
                EndDate: this.newEndDate,
                Active: this.newActive,
            };

            if (this.supportStrategy == "Yes") {                
                req_body.Support =  this.supportStrategy;
                req_body.Strategy = this.strategy?.Goal;
                req_body.SupportStrategy = this.strategy?._id;
                req_body.ServiceCodes = this.formServiceCodes;
            } else {
                req_body.Support = "";
                req_body.Strategy = "";
                req_body.SupportStrategy = null;
                req_body.ServiceCodes = [];
            }
            this.showLoading("updating", "Service Plan");
            axios
                .put(`${url}/ServicePlans/${this.serviceID}`, req_body)
                .then((response) => {
                    this.getServices();
                    if (response.status == 400) {
                        response.json().then(function (data) {
                            alert(data.msg);
                        });
                    }
                    this.showSuccess("updated", "Service Plan");
                    this.close();
                    this.msg = true;
                    this.text = "The service item has been updated successfully.";
                });
        },

        async generateDownloadUrl() {
            return `${url}/ServicePlans/print-pdf?id=${this.serviceID}`;
        },

        async showPrint() {
            const downloadUrl = await this.generateDownloadUrl();
            PrintUtil.showPrintOption(downloadUrl, this.serviceID, this.token, 'ServicePlan');
        },

        async getServices() {
            try {
                this.isLoading = true;
                const response = await axios.get(
                    `${url}/ServicePlans/${this.$route.query.id}`
                );
                this.viewService(response.data.service);
            } catch (e) {
                this.isLoading = false;
                console.log(e);
            }
        },

        addService: function () {
            if (this.validate()) {
                var req_body = {
                    ServiceItem: this.newServiceItem,
                    Type: this.newType,
                    ScheduledTime: this.newScheduledTime,
                    Right: this.HRC,
                    Provider: this.newProvider,
                    LOA: this.newLOA,
                    Days: this.newDays,
                    Description: this.newDescription,
                    Instructions: this.newInstructions,
                    StartDate: this.newStartDate,
                    EndDate: this.newEndDate,
                    Active: this.newActive,
                    ClientID: this.clientID,
                    ServiceCodes: this.formServiceCodes,
                };
                if (this.restriction != "") {
                    req_body.Right = this.HRC;
                }
                if (this.supportStrategy == "Yes") {
                    req_body.Support = this.supportStrategy;
                    req_body.Strategy = this.strategy?.Goal;
                    req_body.SupportStrategy = this.strategy?._id;
                    req_body.ServiceCodes = this.formServiceCodes;
                }
                if (this.newServiceItem === "Add New Item") {
                    this.newServiceItem = "";
                    return;
                }
                this.showLoading("creating", "Service Plan");

                axios.post(`${url}/ServicePlans`, req_body).then((res) => {
                    this.getServices();
                    if (res.status == 400) {
                        res.json().then(function (data) {
                            this.text = data.msg;
                        });
                    }
                    this.showSuccess("added", "Service Plan");
                    this.close();
                    this.msg = true;
                    this.text = "The new service item has been added successfully.";
                });
            }
            this.msg = true;
            this.text = "Please fill out all required fields";
        },

        getServiceItem() {
            axios.get(`${url}/ServicePlans/serviceItem`).then((res) => {
                (this.serviceItems = []),
                    res.data.items.forEach((value) => {
                        this.serviceItems.push(value.Name);
                    });
            });
        },

        createServiceItem() {
            if (this.newServiceItem == "Add New Item") {
                this.newServiceItemAdd = "";
                this.serviceItemDialog = true;
            }
        },

        showServiceItemDialog() {
            this.newServiceItemAdd = "";
            this.serviceItemDialog = true;
        },

        addServiceItem() {
            var req_body = {
                Name: this.newServiceItemAdd,
            };
            if (
                !this.newServiceItemAdd === "" ||
                !this.newServiceItemAdd === undefined ||
                !this.serviceItems.some((data) => data === this.newServiceItemAdd)
            ) {
                axios.post(`${url}/ServicePlans/serviceItem`, req_body).then((res) => {
                    this.newServiceItem = this.newServiceItemAdd;
                    this.getServiceItem();
                });
                this.serviceItemDialog = false;
                this.msg = true;
                this.text = "Item has been added successfully.";
            } else {
                this.msg = true;
                this.text = "Service Item already exist";
            }
        },

        clearFields() {
            this.newServiceItem = "";
            this.newType = "";
            this.newScheduledTime = [];
            this.strategy = "";
            this.supportStrategy = "";
            this.HRC = "";
            this.restriction = "";
            this.newProvider = "";
            this.newLOA = "";
            this.newDays = [];
            this.newDescription = "";
            this.newInstructions = "";
            this.newStartDate = moment(new Date()).format("YYYY-MM-DD");
            this.newEndDate = moment(new Date()).format("YYYY-MM-DD");
            this.newActive = "";
        },

        getSupportStrategies() {
            axios.get(`${url}/support/${this.clientID}`, {
                params: {
                    active: "Active",
                }
            }).then((res) => {
                this.activeStrategies = res.data.supports;
            });
        },

        getRights: function () {
            this.isLoading = true;
            axios.get(`${url}/rights/status/${this.clientID}`).then((res) => {
                this.rights = res.data.rights;
            });
        },

        updateRightsData(restriction) {
            this.newDescription = restriction.Justification;
        },
        async getHabs() {
            axios.get(`${url}/hab/plan/${this.clientID}`).then((res) => {
                this.habs = res.data.habs;
            });
        },

        close() {
            this.$router.go(-1);
        },

        showLoading(action, item) {
            Swal.fire({
                html: `Please wait ${action} ${item}...`,
                allowOutsideClick: false,
                didOpen: () => {
                    Swal.showLoading();
                },
            });
        },

        showSuccess(action, item) {
            Swal.fire({
                icon: "success",
                text: `A new ${item} has been ${action} successfully.`,
                showConfirmButton: false,
                timer: 3000,
            });
        },
        getSupportStrategy(strategyId) {
            this.selectedStrategy = {};
            if (!strategyId) return;

            axios.get(`${url}/support/${strategyId}/item`).then((res) => {
                this.selectedStrategy = res.data.support;
            });
        },
    },
};
</script>
<style>
@media only screen and (min-width: 768px) {
    .mobile {
        display: none;
    }
}

@media only screen and (max-width: 600px) {
    .desktop {
        display: none;
    }
}
</style>
